import styled from 'styled-components';
import { hoverMediaQuery } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const QuestionBlock = styled.a`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  min-width: 420px;
  padding: 24px;
  ${getFont(0)};
  white-space: normal;
  transition: transform 0.15s ease;

  ${hoverMediaQuery`
    &:hover {
      transform: translateY(-2px);
    }
  `};
`;
